import React, { Fragment } from "react";

import {
  IconButton,
  Collapse,
  Grid,
  Typography,
  Box,
  Divider,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";

import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

import { makeStyles } from "@material-ui/core/styles";

const FacebookRow = ({ row, index, open, setOpen }) => {
  const rowHeight = 45;
  const firstLevelFontSize = 13;
  const secondLevelFontSize = 12;
  const secondLevelColumnWidth = 100 / 3 + "%";

  //Convert String to Camel Case
  const camelCaseFormat = (str) => {
    let str_split = str.toLowerCase().split("_");
    for (let i = 0; i < str_split.length; i++) {
      str_split[i] =
        str_split[i].charAt(0).toUpperCase() + str_split[i].substring(1);
    }
    return str_split.join(" ");
  };

  const useStyles = makeStyles((theme) => ({
    tableHeader2: {
      backgroundColor: theme.palette.primary.main,
      fontWeight: "200",
    },
    tabelCell2: {
      width: secondLevelColumnWidth,
      color: theme.palette.primary.contrastText,
    },
    tableHeader3: {
      backgroundColor: theme.palette.primary.light,
      fontWeight: "200",
    },
    iconButtonStyle: {
      "&:focus": {
        outline: "none",
      },
    },
  }));

  const classes = useStyles();

  const Differences = ({ each }) => {
    let kind = "N/A";
    let path = "N/A";
    let old_data = [];
    let new_data = [];
    const mapKind = (value) => {
      let mapped_kind = "";
      if (value === "E") {
        mapped_kind = "Edit";
      } else if (value === "N") {
        mapped_kind = "New";
      } else if (value === "D") {
        mapped_kind = "Delete";
      }
      return mapped_kind;
    };
    if (each.lhs) {
      old_data = JSON.stringify(each.lhs).split(",");
    }
    if (each.rhs) {
      new_data = JSON.stringify(each.rhs).split(",");
    }
    if (each.kind) {
      if (each.kind === "A") {
        kind = mapKind(each.item.kind);
        if (each.item.lhs) {
          old_data = JSON.stringify(each.item.lhs).split(",");
        }
        if (each.item.rhs) {
          new_data = JSON.stringify(each.item.rhs).split(",");
        }
      } else {
        kind = mapKind(each.kind);
      }
    }
    if (each.path) {
      for (let x in each.path) {
        if (path === "N/A") {
          path = each.path[x];
        } else {
          path = path + "." + each.path[x];
        }
      }
    }

    return (
      <Grid container direction="row">
        <Grid
          item
          style={{
            width: "6%",
          }}
        >
          <Typography
            style={{
              fontSize: secondLevelFontSize,
            }}
          >
            {" "}
            {kind}{" "}
          </Typography>{" "}
        </Grid>{" "}
        <Grid
          item
          style={{
            width: "20%",
          }}
        >
          <Typography
            style={{
              fontSize: secondLevelFontSize,
            }}
          >
            {" "}
            {path}{" "}
          </Typography>{" "}
        </Grid>{" "}
        <Grid
          item
          style={{
            width: "37%",
          }}
        >
          {" "}
          {old_data.map((each) => {
            return (
              <Typography
                style={{
                  fontSize: secondLevelFontSize,
                }}
              >
                {" "}
                {each}{" "}
              </Typography>
            );
          })}{" "}
        </Grid>{" "}
        <Grid
          item
          style={{
            width: "37%",
          }}
        >
          {" "}
          {new_data.map((each) => {
            return (
              <Typography
                style={{
                  fontSize: secondLevelFontSize,
                }}
              >
                {" "}
                {each}{" "}
              </Typography>
            );
          })}{" "}
        </Grid>{" "}
      </Grid>
    );
  };

  const Errors = ({ code, store_name, message }) => {
    return (
      <Grid container direction="row">
        <Grid
          item
          style={{
            width: "15%",
          }}
        >
          <Typography
            style={{
              fontSize: secondLevelFontSize,
            }}
          >
            {" "}
            {code}{" "}
          </Typography>{" "}
        </Grid>{" "}
        <Grid
          item
          style={{
            width: "20%",
          }}
        >
          <Typography
            style={{
              fontSize: secondLevelFontSize,
            }}
          >
            {" "}
            {store_name}{" "}
          </Typography>{" "}
        </Grid>{" "}
        <Grid
          item
          style={{
            width: "65%",
          }}
        >
          <Typography
            style={{
              fontSize: secondLevelFontSize,
            }}
          >
            {" "}
            {message}{" "}
          </Typography>{" "}
        </Grid>{" "}
      </Grid>
    );
  };
  const FirstLevelCollapse = () => {
    return (
      <TableRow
        style={{
          backgroundColor: "#f6f7ff",
        }}
      >
        <TableCell
          style={
            open === index
              ? {
                  padding: "10px 20px 10px 20px",
                }
              : {
                  padding: "0px",
                }
          }
          colSpan={5}
        >
          <Collapse in={open === index} timeout="auto" unmountOnExit>
            <Box>
              <Grid container direction="row" spacing={1}>
                <Grid item xs={12}>
                  <Typography
                    style={{
                      fontSize: secondLevelFontSize,
                    }}
                  >
                    Action:{" "}
                    <strong>
                      {" "}
                      {row.action ? camelCaseFormat(row.action) : "N/A"}{" "}
                    </strong>{" "}
                  </Typography>{" "}
                </Grid>{" "}
                {row.error_list ? (
                  <Grid item xs={12}>
                    <Typography
                      style={{
                        fontSize: secondLevelFontSize,
                      }}
                    >
                      Errors:
                    </Typography>{" "}
                  </Grid>
                ) : null}{" "}
                {row.error_list ? (
                  <Grid
                    item
                    xs={12}
                    style={{
                      padding: 10,
                    }}
                  >
                    <Paper
                      style={{
                        padding: 10,
                      }}
                    >
                      <Grid container direction="row" spacing={1}>
                        <Grid item xs={12}>
                          <Grid container direction="row">
                            <Grid
                              item
                              style={{
                                width: "15%",
                              }}
                            >
                              <Typography
                                style={{
                                  fontSize: secondLevelFontSize,
                                }}
                              >
                                <strong> Error Code </strong>{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                            <Grid
                              item
                              style={{
                                width: "20%",
                              }}
                            >
                              <Typography
                                style={{
                                  fontSize: secondLevelFontSize,
                                }}
                              >
                                <strong> Store </strong>{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                            <Grid
                              item
                              style={{
                                width: "65%",
                              }}
                            >
                              <Typography
                                style={{
                                  fontSize: secondLevelFontSize,
                                }}
                              >
                                <strong> Message </strong>{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                          </Grid>{" "}
                        </Grid>{" "}
                        <Grid item xs={12}>
                          <Divider />
                        </Grid>{" "}
                        <Grid item xs={12}>
                          {" "}
                          {
                            Object.entries(row.error_list).map(
                              ([code, store]) => {
                                let error_array = [];
                                for (let x in store) {
                                  let error_code = "";
                                  let store_name = "";
                                  let message = "";
                                  if (parseFloat(x) === 0) {
                                    error_code = code;
                                  } else {
                                    error_code = "";
                                  }
                                  store_name = store[x].stores;
                                  message = store[x].messages;
                                  error_array.push({
                                    code: error_code,
                                    store_name: store_name,
                                    message: message,
                                  });
                                }
                                return error_array.map((each) => {
                                  return (
                                    <Errors
                                      key={index}
                                      code={each.code}
                                      store_name={each.store_name}
                                      message={each.message}
                                    />
                                  );
                                });
                              }
                            )
                            // row.error_list.map((each, index) => {
                            //   return (
                            //     <Errors key={index} each={each} index={index} />
                            //   );
                            // })
                          }{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Paper>{" "}
                  </Grid>
                ) : null}{" "}
                <Grid item xs={12}>
                  <Typography
                    style={{
                      fontSize: secondLevelFontSize,
                    }}
                  >
                    Differences:{" "}
                    {row.differences && row.differences.length > 0 ? null : (
                      <strong> "N/A" </strong>
                    )}{" "}
                  </Typography>{" "}
                </Grid>{" "}
                <Grid
                  item
                  xs={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Paper
                    style={{
                      padding: 10,
                    }}
                  >
                    <Grid container direction="row" spacing={1}>
                      <Grid item xs={12}>
                        <Grid container direction="row">
                          <Grid
                            item
                            style={{
                              width: "6%",
                            }}
                          >
                            <Typography
                              style={{
                                fontSize: secondLevelFontSize,
                              }}
                            >
                              <strong> Kind </strong>{" "}
                            </Typography>{" "}
                          </Grid>{" "}
                          <Grid
                            item
                            style={{
                              width: "20%",
                            }}
                          >
                            <Typography
                              style={{
                                fontSize: secondLevelFontSize,
                              }}
                            >
                              <strong> Path </strong>{" "}
                            </Typography>{" "}
                          </Grid>{" "}
                          <Grid
                            item
                            style={{
                              width: "37%",
                            }}
                          >
                            <Typography
                              style={{
                                fontSize: secondLevelFontSize,
                              }}
                            >
                              <strong> Old Data </strong>{" "}
                            </Typography>{" "}
                          </Grid>{" "}
                          <Grid
                            item
                            style={{
                              width: "37%",
                            }}
                          >
                            <Typography
                              style={{
                                fontSize: secondLevelFontSize,
                              }}
                            >
                              <strong> New Data </strong>{" "}
                            </Typography>{" "}
                          </Grid>{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>{" "}
                      <Grid item xs={12}>
                        {" "}
                        {row.differences && row.differences.length > 0
                          ? row.differences.map((each, index) => {
                              return <Differences key={index} each={each} />;
                            })
                          : null}{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                  </Paper>{" "}
                </Grid>{" "}
              </Grid>{" "}
            </Box>{" "}
          </Collapse>{" "}
        </TableCell>{" "}
      </TableRow>
    );
  };

  return (
    <Fragment>
      <TableRow
        key={row.id}
        style={
          open === index
            ? {
                backgroundColor: "#f6f7ff",
                height: rowHeight,
              }
            : {
                height: rowHeight,
              }
        }
      >
        <TableCell
          style={{
            width: "4%",
          }}
          align="center"
        >
          {" "}
          {row.differences && row.differences.length > 0 ? (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => {
                if (open !== index) {
                  setOpen(index);
                } else {
                  setOpen("");
                }
              }}
              className={classes.iconButtonStyle}
            >
              {open === index ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}{" "}
            </IconButton>
          ) : null}{" "}
        </TableCell>{" "}
        <TableCell
          style={{
            fontSize: firstLevelFontSize,
          }}
          align="left"
        >
          {row.created_at}{" "}
        </TableCell>{" "}
        <TableCell
          style={{
            fontSize: firstLevelFontSize,
          }}
          align="left"
        >
          {row.user}{" "}
        </TableCell>{" "}
        <TableCell
          style={{
            fontSize: firstLevelFontSize,
          }}
          align="left"
        >
          {row.description}{" "}
        </TableCell>{" "}
      </TableRow>{" "}
      <FirstLevelCollapse />
    </Fragment>
  );
};

export default FacebookRow;
